import { EventCategoryLegacy } from './types/event';
import { API_BASE_URL } from './utils/apiUrlConfig';

// API Configuration
export const API_CONFIG = {
  BASE_URL: API_BASE_URL,
  TIMEOUT: 10000,
  RETRY_ATTEMPTS: 3,
  RETRY_DELAY: 1000,
  ENDPOINTS: {
    EVENTS: '/api/events',
    ORGANIZATIONS: '/api/organizations',
    USERS: '/api/users',
    STAFF: '/api/staff',
    EVENT_CATEGORIES: '/api/event-categories'
  }
};

// Event Categories with French translations
export const EVENT_CATEGORIES: Record<EventCategoryLegacy, string> = {
  conference: 'Conférence',
  workshop: 'Atelier',
  meetup: 'Meetup',
  hackathon: 'Hackathon',
  webinar: 'Webinaire',
  other: 'Autre'
};

// Common tags for events
export const EVENT_TAGS = [
  'tech',
  'design',
  'business',
  'startup',
  'innovation',
  'networking',
  'education',
  'career'
] as const;

// Interface Configuration
export const UI_CONFIG = {
  ITEMS_PER_PAGE: 12,
  MAX_DESCRIPTION_LENGTH: 300,
  DEBOUNCE_DELAY: 300,
  IMAGE_UPLOAD_SIZE_LIMIT: 5 * 1024 * 1024, // 5MB
  DEFAULT_IMAGE: '/placeholder-event.jpg'
};

// Date format options
export const DATE_FORMAT_OPTIONS = {
  FULL: {
    weekday: 'long',
    day: 'numeric',
    month: 'long',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false
  },
  SHORT: {
    day: 'numeric',
    month: 'short',
    hour: '2-digit',
    minute: '2-digit'
  }
} as const;

// Error messages in French
export const ERROR_MESSAGES = {
  NETWORK_ERROR: 'Une erreur de connexion est survenue',
  TIMEOUT: 'La requête a pris trop de temps à répondre',
  NOT_FOUND: 'La ressource demandée n\'existe pas',
  UNAUTHORIZED: 'Vous devez être connecté pour effectuer cette action',
  FORBIDDEN: 'Vous n\'avez pas les droits nécessaires',
  VALIDATION: 'Les données saisies sont invalides',
  CONFLICT: 'Un conflit est survenu avec une ressource existante',
  SERVER_ERROR: 'Une erreur inattendue s\'est produite',
  DEFAULT: 'Une erreur est survenue'
} as const;
